import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

export const ProLockDialog = ({ open, onOpenChange, what = "Themes" }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-panel border-line max-w-md" data-testid="pro-lock-dialog">
      <Crown className="w-7 h-7 text-amber-400" />
      <DialogTitle className="font-display text-3xl text-amber-50">{what} are part of Pro</DialogTitle>
      <DialogDescription className="text-slate-400 text-sm">
        Free accounts can switch between Lorely Dark and Lorely Light. Pro unlocks every preset theme, your own themes and all the scene break designs.
      </DialogDescription>
      <div className="flex gap-2 pt-2">
        <Link to="/pricing" className="inline-flex items-center gap-1.5 rounded-full bg-amber-500 hover:bg-amber-400 text-onaccent text-sm font-semibold px-5 h-10" data-testid="pro-lock-upgrade">
          <Crown className="w-4 h-4" /> See Pro
        </Link>
        <button onClick={() => onOpenChange(false)} className="rounded-full border border-line px-5 h-10 text-sm text-slate-300 hover:border-amber-500/40" data-testid="pro-lock-close">Not now</button>
      </div>
    </DialogContent>
  </Dialog>
);
